import _slicedToArray from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .contact-change-btn {\n    color: ", ";\n  }\n\n  .checklist {\n    width: fit-content;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { PhoneType, TwoFactorAuthenticationMethods } from '@tradingblock/types';
import PrimaryButton from '../components/PrimaryButton';
import { ContextTypes } from '../TwoFactorAuthenticationSetup';
import { CheckboxInput } from '../../fields';
;
var StyledContactInfo = styled.div(_templateObject(), function (params) {
  return params.context === ContextTypes.login ? 'var(--teal)' : 'var(--blue)';
});

var ContactInfo = function ContactInfo(_ref) {
  var contactInfoToDisplay = _ref.contactInfoToDisplay,
      handleContactInfoUpdate = _ref.handleContactInfoUpdate,
      primaryButtonProps = _ref.primaryButtonProps,
      setPhoneNumberToUseForTwoFactorAuthentication = _ref.setPhoneNumberToUseForTwoFactorAuthentication,
      twoFactorAuthenticationMethodToBeVerified = _ref.twoFactorAuthenticationMethodToBeVerified,
      context = _ref.context,
      phoneNumberToUseForTwoFactorAuthentication = _ref.phoneNumberToUseForTwoFactorAuthentication,
      genericErrorMsg = _ref.genericErrorMsg,
      allowAbilityToCancel = _ref.allowAbilityToCancel,
      cancelBtnProps = _ref.cancelBtnProps,
      smsTwoFactorAuthenticationMethodVerifiedPhoneData = _ref.smsTwoFactorAuthenticationMethodVerifiedPhoneData;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      phonesSortedByType = _useState2[0],
      setPhonesSortedByType = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showGenericErrorMsg = _useState4[0],
      setShowGenericErrorMsg = _useState4[1];

  useEffect(function () {
    if (twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.sms) {
      if (typeof contactInfoToDisplay !== 'object') {
        setShowGenericErrorMsg(true);
        return;
      }

      var tempPhonesSortedByType = [];
      var mobilePhoneData = contactInfoToDisplay.find(function (phoneData) {
        return phoneData.type === PhoneType.Mobile;
      });
      var homePhoneData = contactInfoToDisplay.find(function (phoneData) {
        return phoneData.type === PhoneType.Home;
      });
      var workPhoneData = contactInfoToDisplay.find(function (phoneData) {
        return phoneData.type === PhoneType.Work;
      });

      if (mobilePhoneData && (!smsTwoFactorAuthenticationMethodVerifiedPhoneData || smsTwoFactorAuthenticationMethodVerifiedPhoneData && smsTwoFactorAuthenticationMethodVerifiedPhoneData.type !== PhoneType.Mobile && smsTwoFactorAuthenticationMethodVerifiedPhoneData.phoneNumber !== mobilePhoneData.phoneNumber)) {
        tempPhonesSortedByType.push(mobilePhoneData);
      }

      if (homePhoneData && (!smsTwoFactorAuthenticationMethodVerifiedPhoneData || smsTwoFactorAuthenticationMethodVerifiedPhoneData && smsTwoFactorAuthenticationMethodVerifiedPhoneData.type !== PhoneType.Home && smsTwoFactorAuthenticationMethodVerifiedPhoneData.phoneNumber !== homePhoneData.phoneNumber)) {
        tempPhonesSortedByType.push(homePhoneData);
      }

      if (workPhoneData && (!smsTwoFactorAuthenticationMethodVerifiedPhoneData || smsTwoFactorAuthenticationMethodVerifiedPhoneData && smsTwoFactorAuthenticationMethodVerifiedPhoneData.type !== PhoneType.Work && smsTwoFactorAuthenticationMethodVerifiedPhoneData.phoneNumber !== workPhoneData.phoneNumber)) {
        tempPhonesSortedByType.push(workPhoneData);
      }

      setPhonesSortedByType(tempPhonesSortedByType);
    }
  }, []);
  useEffect(function () {
    if (phonesSortedByType.length > 0 && setPhoneNumberToUseForTwoFactorAuthentication) {
      setPhoneNumberToUseForTwoFactorAuthentication(phonesSortedByType[0]);
    }
  }, [phonesSortedByType]);

  var getMainContent = function getMainContent() {
    if (twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.email) {
      return React.createElement(React.Fragment, null, React.createElement("p", null, "Let's verify your email."), React.createElement("p", null, "We'll email a security code to: ", contactInfoToDisplay), React.createElement("p", null, "Need to update the email? Click ", React.createElement("button", {
        type: "button",
        className: "contact-change-btn",
        onClick: handleContactInfoUpdate
      }, "here"), "."));
    } else if (twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.sms) {
      if (contactInfoToDisplay.length === 0) {
        return React.createElement("p", null, "You do not have any phone numbers attached to your account. Click ", React.createElement("button", {
          type: "button",
          className: "phone-change-btn",
          onClick: handleContactInfoUpdate
        }, "here"), " to add one.");
      }

      if (contactInfoToDisplay.length > 0 && phonesSortedByType.length === 0) {
        return React.createElement("p", null, "You have only one phone number or the same phone number listed for your home, work and mobile. This phone number is already verified for two-factor authentication (2FA). If you would like to use another phone number for a two-factor authentication method, please change your home, work or mobile phone number by clicking ", React.createElement("button", {
          type: "button",
          className: "phone-change-btn",
          onClick: handleContactInfoUpdate
        }, "here"), ".");
      }

      return React.createElement(React.Fragment, null, React.createElement("p", null, "We'll text a security code to a phone number below to verify it."), React.createElement("ol", {
        className: "checklist"
      }, phoneNumberToUseForTwoFactorAuthentication && phonesSortedByType.map(function (phoneData) {
        if (phoneNumberToUseForTwoFactorAuthentication && !smsTwoFactorAuthenticationMethodVerifiedPhoneData || smsTwoFactorAuthenticationMethodVerifiedPhoneData && phoneData.type !== smsTwoFactorAuthenticationMethodVerifiedPhoneData.type && phoneData.phoneNumber !== smsTwoFactorAuthenticationMethodVerifiedPhoneData.phoneNumber) {
          return React.createElement("li", {
            key: "checklist-option-".concat(phoneData.type)
          }, React.createElement(CheckboxInput, {
            id: "".concat(phoneData.phoneNumber, "-").concat(phoneData.type),
            checked: phoneNumberToUseForTwoFactorAuthentication && phoneData.phoneNumber === phoneNumberToUseForTwoFactorAuthentication.phoneNumber && phoneData.type === phoneNumberToUseForTwoFactorAuthentication.type,
            label: "".concat(phoneData.phoneNumber, " (").concat(phoneData.type, ")"),
            onchange: function onchange() {
              return setPhoneNumberToUseForTwoFactorAuthentication(phoneData);
            }
          }));
        }
      })), React.createElement("p", null, "Need to update a phone number? Click ", React.createElement("button", {
        type: "button",
        className: "contact-change-btn",
        onClick: handleContactInfoUpdate
      }, "here"), "."));
    }
  };

  if (showGenericErrorMsg) {
    return React.createElement("p", {
      className: "error"
    }, genericErrorMsg);
  }

  return React.createElement(StyledContactInfo, {
    context: context
  }, getMainContent(), React.createElement("div", {
    className: "btn-wrapper"
  }, allowAbilityToCancel && cancelBtnProps && React.createElement("button", Object.assign({
    type: "button"
  }, Object.assign({}, cancelBtnProps, {
    className: "".concat(cancelBtnProps.className ? cancelBtnProps.className : '', " ").concat((twoFactorAuthenticationMethodToBeVerified !== TwoFactorAuthenticationMethods.sms || twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.sms && phonesSortedByType.length > 0) && 'mr-3')
  })), "Cancel"), (twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.email || twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.sms && phonesSortedByType.length > 0) && React.createElement(PrimaryButton, Object.assign({}, primaryButtonProps))));
};

export default ContactInfo;